
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { placeTypeSort, plural } from '../../utils/utils';
import styles from './SearchResults.css';
import withStyles from '../../decorators/withStyles';


class SearchResults extends Component {

  static PropTypes = {
    handleMouseOver: PropTypes.func.isRequired,
    handleLinkMouseOver: PropTypes.func.isRequired,
    results: PropTypes.array.isRequired,
    links: PropTypes.object.isRequired,
    selectedIdx: PropTypes.number.isRequired,
    query: PropTypes.object.isRequired,
  };

  lastResult = i => {
    if (this.props.links.length > 0) {
      return false;
    } else {
      if (i === this.props.results.length - 1) {
        return "lastResult";
      } else {
        return "";
      }
    }
  };

  render() {
    return (
      <div className="SearchResults">
        {this.props.results.length > 0 ?
          <ul>
            <div className="results">
            {this.props.results.map((place, i) => {
              var name;
              var to;
              to = {pathname: `/${place.placetype}/${place.id}`,
                state: {place: {id: place.id, type: place.placetype}}};
              name = place.long_name.length < 45 ? place.long_name : place.name;
              if (i === this.props.selectedIdx) {
                return (
                  <Link to={to} key={`/${place.placetype}/${place.id}`}
                        className={this.lastResult(i)}>
                    <li className="selected" onClick={this.props.handleClick}>
                      {/*name.split(",").map((elem, i) => <span>{elem}{i !== name.match(/,/g).length ? "," : ""}</span>)*/}
                      <span>{name}</span>
                    </li>
                  </Link>)
              } else {
                return (
                  <Link to={to} key={`/${place.placetype}/${place.id}`}
                        className={this.lastResult(i)}>
                    <li onMouseOver={this.props.handleMouseOver.bind(this, i)} onClick={this.props.handleClick}>
                      {/*name.split(",").map((elem, i) => <span>{elem}{i !== name.match(/,/g).length ? "," : ""}</span>)*/}
                      <span>{name}</span>
                    </li>
                  </Link>
                )
              }
            })}
              </div>
            {this.props.links.length > 0 ? <div className="related-places">
              {this.props.links[0].container ?
                <p className="link-group-header"><strong>Places within {this.props.links[0].container.name}</strong></p>
                :
                <p className="link-group-header"><strong>Related places</strong></p>
              }
              {this.props.links.map((link, i) => {
                return <Link to={link}
                             key={link.text}
                             className={i === 0 ? "firstLink" : ""}>
                  <li onMouseOver={this.props.handleMouseOver.bind(this, this.props.results.length + i)}
                      onClick={this.props.handleClick}
                      className={this.props.selectedIdx === this.props.results.length + i ? "selected" : ""}>
                    {link.text}
                  </li>
                </Link>
              })
              }
            </div> : null}

          </ul>
          : null
        }
      </div>
    )
  }
}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(SearchResults);
